// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import englishTranslation from "./en";
var tagalogTranslation = {
    translations: {
        ballotPrivacy: englishTranslation.translations.ballotPrivacy,
        startup: {
            error: "Hindi masimulan ang portal ng pagboto. Pakisubukang muli.",
            retry: "Subukang muli",
        },
        contactChannel: {
            change: "Paraan ng pakikipag-ugnayan",
            updated: "Napalitan na ang iyong contact. Doon na ipapadala ang mga code at abiso.",
            cancelled: "Hindi napalitan ang iyong contact.",
            failed: "Hindi namin mabago kung paano ka namin kokontakin. Subukang muli mamaya o makipag-ugnayan sa support.",
            close: "Isara",
        },
        common: {
            goBack: "Bumalik",
            showMore: "Lakihan ang nakikita",
            showLess: "Bawasan ang nakikita",
        },
        audioInstructions: {
            screens: {
                "election-chooser": "Ipinapakita ng pahinang ito ang mga halalang maaari mong botohan. Gamitin ang Tab key upang lumipat mula sa isang halalan papunta sa susunod. May button ang bawat halalan para simulan ang pagboto. Pindutin ang Enter sa button na iyon upang buksan ang balota nito.",
                "start": "Ipinapaliwanag ng pahinang ito kung paano bumoto. Una, pipiliin mo ang iyong mga opsyon, pagkatapos ay susuriin mo ang mga ito, at saka mo ihuhulog ang iyong balota. Gamitin ang Tab key upang marating ang button na nagsisimula ng pagboto at pindutin ang Enter. Kung may ipinapakitang deklarasyon, lagyan muna ng tsek ang checkbox nito gamit ang Space bar.",
                "ballot": "Ito ang iyong balota. Ang bawat tanong ay isang pangkat ng mga opsyon, at sinasabi ng tanong kung ilan ang maaari mong piliin. Gamitin ang Tab key upang lumipat sa mga opsyon at ang Space bar upang pumili o mag-alis ng pili. Kapag tapos ka na, pumunta sa button para magpatuloy, sa dulo ng pahina, at pindutin ang Enter upang suriin ang iyong mga pinili. May button din para burahin ang lahat ng iyong pinili. Walang maihuhulog hangga't hindi mo kinukumpirma sa pahina ng pagsusuri.",
                "review": "Ipinapakita ng pahinang ito ang mga pinili mo. Suriin itong mabuti. Para may baguhin, gamitin ang button para i-edit ang iyong balota. Para bumoto, pumunta sa button para ihulog ang iyong balota at pindutin ang Enter. Nasa itaas ng pahina ang iyong Ballot ID. Maaari mo itong kopyahin upang mahanap ang iyong balota sa ibang pagkakataon.",
                "confirmation": "Naihulog na ang iyong boto. Ipinapakita ng pahinang ito ang iyong Ballot ID, na magagamit mo upang tiyaking naitala ang iyong balota. Maaari mo itong kopyahin o i-print ang pahinang ito. Kapag tapos ka na, gamitin ang button sa dulo ng pahina upang tapusin.",
                "audit": "Sa pahinang ito, maaari mong i-audit ang iyong balota sa halip na ihulog ito. Ipinapakita nito ang impormasyong masusuri mo gamit ang ballot verifier. Hindi naihuhulog ang balotang na-audit, kaya bumalik pagkatapos sa iyong balota upang bumoto.",
                "ballot-locator": "Sa pahinang ito, matitiyak mong naitala ang isang balota. I-type o i-paste ang isang Ballot ID sa text field at pindutin ang Enter. Lalabas ang resulta sa ibaba ng field.",
                "support-materials": "Ipinapakita ng pahinang ito ang mga dokumentong tutulong sa iyong bumoto. Gamitin ang Tab key upang lumipat sa mga ito at pindutin ang Enter sa button ng isang dokumento upang buksan ito. Gamitin ang button para bumalik sa listahan ng mga halalan.",
            },
        },
        a11y: {
            skipToContent: "Lumaktaw sa pangunahing nilalaman",
            helpAbout: "Tulong tungkol sa {{topic}}",
            previewMaterial: "I-preview ang {{title}}",
            ballotsTable: "Mga balota",
            ballotLocatorTabs: "Mga seksyon ng ballot locator",
            ballotIdLabel: "Ballot ID",
            votingProgress: "Progreso ng pagboto",
            stepOf: "Hakbang {{current}} ng {{total}}",
            selectUpTo_one: "Pumili ng hanggang {{count}} opsyon",
            selectUpTo_many: "Pumili ng hanggang {{count}} na opsyon",
            selectUpTo_other: "Pumili ng hanggang {{count}} na opsyon",
            selectExactly_one: "Pumili ng {{count}} opsyon",
            selectExactly_many: "Pumili ng {{count}} na opsyon",
            selectExactly_other: "Pumili ng {{count}} na opsyon",
            selectBetween: "Pumili sa pagitan ng {{min}} at {{max}} na opsyon",
        },
        candidatesList: {
            collapseToggle: "I-toggle ang listahan {{listTitle}}",
            showCandidates: "Ipakita ang mga kandidato",
            hideCandidates: "Itago ang mga kandidato",
            selectedCandidates_one: "{{count}} kandidatong napili",
            selectedCandidates_many: "{{count}} kandidatong napili",
            selectedCandidates_other: "{{count}} kandidatong napili",
            expandAll: "Palawakin lahat",
            collapseAll: "Bawasan lahat",
        },
        breadcrumbSteps: {
            electionList: "Mga Balota",
            ballot: "Balota",
            review: "Suriin",
            confirmation: "Kumpirmahin",
            audit: "Audit",
        },
        footer: {
            poweredBy: "Pinapagana ng <1></1>",
        },
        contest: {
            acclamation: {
                description: "Ang paligsahang ito ay napagpasyahan sa pamamagitan ng aklamasyon. Ang mga kandidato nito ay nahalal nang walang botohan, kaya walang opsyong mapipili at walang botong naitatala.",
            },
            paperBallot: {
                voteForNoMoreThan_one: "Bumoto ng hindi hihigit sa {{count}}",
                voteForNoMoreThan_many: "Bumoto ng hindi hihigit sa {{count}}",
                voteForNoMoreThan_other: "Bumoto ng hindi hihigit sa {{count}}",
            },
        },
        votingScreen: {
            backButton: "Bumalik",
            reviewButton: "Susunod",
            clearButton: "Burahin ang mga napili",
            ballotHelpDialog: {
                title: "Tungkol sa screen ng balota",
                content: "Ipinapakita sa screen na ito ang mga paligsahan na maaari mong botohan. I-activate ang checkbox sa kanan para pumili ng Kandidato/Sagot. I-reset sa “<b>Burahin ang mga napili</b>”, pumunta sa susunod sa “<b>Susunod</b>”.",
                ok: "OK",
            },
            nonVotedDialog: {
                title: "Di-wasto o blangkong boto",
                content: "Ang ilan sa iyong mga sagot ay magreresulta sa pagkaka-invalidate o pagkakaroon ng blangko sa balota sa isa o higit pang mga paligsahan.",
                ok: "Bumalik at suriin",
                continue: "Ipagpatuloy",
                cancel: "Kanselahin",
            },
            warningDialog: {
                title: "Suriin ang iyong balota",
                content: "Ang iyong balota ay naglalaman ng mga pagpili na maaaring mangailangan ng iyong pansin (tulad ng pagpili ng mas kaunting opsyon kaysa sa pinapayagan). Ang iyong balota ay wasto at biblangin ayon sa iyong isinumite.",
                ok: "Bumalik at suriin",
                continue: "Magpatuloy",
                cancel: "Kanselahin",
            },
            blankBallotDialog: {
                title: "Wala kang napiling kandidato",
                content: "Wala kang ginawang pagpili. Ang iyong balota ay isusumite bilang blangkong balota, na isang wasto at sinasadyang pagpili at ibibilang bilang ganoon.",
                continue: "Magpatuloy",
                cancel: "Kanselahin",
            },
        },
        startScreen: {
            startButton: "Simulan ang Pagboto",
            declineToVoteButton: "Tumangging bumoto",
            declineToVoteDialog: {
                title: "Kumpirmahin ang pagtangging bumoto",
                content: "Sigurado ka bang nais mong tumangging bumoto?<br />Dadalhin ka diretso sa review at mase-save ang iyong status ng partisipasyon bilang <b>Tumangging bumoto</b>.",
                continue: "Tumangging bumoto",
                cancel: "Kanselahin",
            },
            instructionsTitle: "Paano bumoto",
            instructionsDescription: "Sundin ang mga hakbang na ito para bumoto:",
            step1Title: "1. Piliin ang iyong mga sagot",
            step1Description: "Pumili sa bawat paligsahan isa-isa. Maaari mong i-edit ang iyong balota hanggang handa ka.",
            step2Title: "2. Suriin ang iyong balota",
            step2Description: "Ie-encrypt namin ang iyong balota at ipapakita ang huling pagsusuri. Makakatanggap ka ng natatanging tracker ID.",
            step3Title: "3. I-submit ang iyong balota",
            step3Description: "I-submit ang iyong balota upang ito ay tamang maitala, o suriin ito upang tiyakin na ito ay tama ang pagkaka-encrypt.",
        },
        reviewScreen: {
            castRecovery: {
                uncertain: "Hindi pa nakumpirma ang resulta ng pagboto. Maaari mong subukan muli ang parehong kahilingan o tingnan ang Ballot ID bago magsimulang muli.",
                checkBallot: "Tingnan ang balota",
            },
            acclamation: {
                title: "Napagpasyahan sa pamamagitan ng aklamasyon",
                helpDialog: {
                    title: "Impormasyon: Aklamasyon",
                    content: "Ipinapakita sa screen na ito ang napagpasyahan sa pamamagitan ng aklamasyon. Dahil walang opsyong mapipili, walang balotang isusumite at walang maberipika pagkatapos.",
                    ok: "OK",
                },
                description: "Suriin ang napagpasyahan sa pamamagitan ng aklamasyon sa halalang ito. Walang balotang isusumite.",
                finishButton: "Tapusin",
            },
            title: "Suriin ang iyong balota",
            description: "I-click ang “<b>I-edit ang balota</b>” para baguhin ang mga napili, “<b>I-submit ang balota</b>” para kumpirmahin, o “<b>Suriin ang balota</b>” para sa audit.",
            descriptionNoAudit: "I-click ang “<b>I-edit ang balota</b>” para baguhin ang mga napili, o “<b>I-submit ang balota</b>” para kumpirmahin.",
            backButton: "I-edit ang balota",
            castBallotButton: "I-submit ang balota",
            auditButton: "Suriin ang balota",
            copyBallotId: "Kopyahin ang ballot ID",
            ballotIdCopied: "Nakopya ang ballot ID",
            ballotIdCopyError: "Hindi makopya ang ballot ID",
            reviewScreenHelpDialog: {
                title: "Tungkol sa screen ng pagsusuri",
                content: "Maaari mo ditong suriin ang iyong mga napili bago i-submit ang iyong balota.",
                ok: "OK",
            },
            ballotIdHelpDialog: {
                title: "Hindi pa na-submit ang boto",
                content: "<p>Ito ang iyong Ballot Tracker ID, ngunit <b>hindi pa nai-submit ang iyong boto</b>. Kung susubukan mong i-track ang balota, hindi mo ito mahahanap.</p><p>Ang dahilan kung bakit ipinapakita namin ang Ballot Tracker ID sa yugtong ito ay upang masuri mo ang pagiging tama ng naka-encrypt na balota bago ito i-submit.</p>",
                ok: "Naiintindihan ko na hindi pa nai-submit ang aking boto",
                cancel: "Kanselahin",
            },
            auditBallotHelpDialog: {
                title: "Nais mo bang i-audit ang balota?",
                content: "<p>Pakitandaan na ang pag-audit ng iyong balota ay magpapawalang-bisa dito, at kakailanganin mong magsimulang muli sa proseso ng pagboto. Sa proseso ng audit, maari mong tiyakin na ang iyong balota ay tamang naka-encode, ngunit ito ay nangangailangan ng mga advanced na teknikal na hakbang. Inirerekomenda naming magpatuloy ka lang kung ikaw ay kumpiyansa sa iyong kakayahang teknikal. Kung nais mo lamang i-submit ang iyong balota, i-click ang <u>Kanselahin</u> upang bumalik sa screen ng pagsusuri ng balota.</p>",
                ok: "Oo, nais kong ibasura ang aking balota upang suriin ito",
                cancel: "Kanselahin",
            },
            confirmCastVoteDialog: {
                title: "Sigurado ka bang nais mong i-submit ang iyong boto?",
                content: "Pagkatapos mong kumpirmahin, ang iyong boto ay mai-susubmit.",
                ok: "Oo, nais kong i-submit ang aking boto",
                cancel: "Kanselahin",
            },
            confirmCastBlankBallotDialog: {
                title: "Sigurado ka bang nais mong magsumite ng blangkong balota?",
                content: "Wala kang napiling kandidato. Pagkatapos mong kumpirmahin, ang iyong balota ay isusumite bilang blangko.",
                ok: "Oo, nais kong isumite ang aking blangkong balota",
                cancel: "Kanselahin",
            },
            unfilledContestsDialog: {
                title: "May mga pagpiling hindi napunan",
                content: "Maaari mong iwanang blangko ang isang pagpili o pumili ng mas kaunting opsyon kaysa sa pinapayagan. Suriin ang sumusunod bago magpatuloy.",
                selected: "{{selected}} sa {{max}} ang napili",
                nothingSelected: "Walang napili",
                ok: "Magpatuloy sa mga pagpiling ito",
                cancel: "Suriin ang mga pinili",
            },
            error: {
                NETWORK_ERROR: "Nagkaroon ng problema sa network. Pakisubukan ulit mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                UNABLE_TO_FETCH_DATA: "Nagkaroon ng problema sa pagkuha ng data. Pakisubukan ulit mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                LOAD_ELECTION_EVENT: "Hindi ma-load ang kaganapan ng halalan. Pakisubukan ulit mamaya.",
                CAST_VOTE: "Nagkaroon ng hindi inaasahang error habang bumoboto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_CheckStatusFailed: "Hindi pinapayagan ng halalan ang pagboto. Ang halalan ay maaaring sarado, naka-archive, o maaari kang bumoto sa labas ng itinakdang panahon.",
                CAST_VOTE_AreaNotFound: "Nagkaroon ng error habang bumoboto: Hindi natagpuan ang lugar. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_InternalServerError: "Nagkaroon ng internal na error habang bumoboto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_QueueError: "Nagkaroon ng problema sa pagproseso ng iyong boto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_Unauthorized: "Hindi ka awtorisadong bumoto. Pakikontak ang suporta para sa tulong.",
                CAST_VOTE_ElectionEventNotFound: "Hindi matagpuan ang kaganapang elektoral. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_ElectoralLogNotFound: "Hindi matagpuan ang iyong tala ng pagboto. Pakikontak ang suporta para sa tulong.",
                CAST_VOTE_CheckPreviousVotesFailed: "Nagkaroon ng error habang sinusuri ang iyong status sa pagboto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_GetClientCredentialsFailed: "Nabigo sa pag-verify ng iyong mga kredensyal. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_GetAreaIdFailed: "Nagkaroon ng error sa pag-verify ng iyong lugar ng pagboto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_GetTransactionFailed: "Nagkaroon ng error sa pagproseso ng iyong boto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_DeserializeBallotFailed: "Nagkaroon ng error sa pagbasa ng iyong balota. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_DeserializeContestsFailed: "Nagkaroon ng error sa pagbasa ng iyong mga napili. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_PokValidationFailed: "Nabigo sa pag-validate ng iyong boto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_UuidParseFailed: "Nagkaroon ng error sa pagproseso ng iyong kahilingan. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_unexpected: "Nagkaroon ng hindi kilalang error habang bumoboto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                CAST_VOTE_timeout: "May error sa timeout sa pagboto. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
                CAST_VOTE_InsertFailedExceedsAllowedRevotes: "Lumampas ka na sa limitasyon ng muling pagboto. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
                CAST_VOTE_CheckRevotesFailed: "Lumampas ka na sa pinapayagang bilang ng muling pagboto. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
                CAST_VOTE_CheckVotesInOtherAreasFailed: "Nakaboto ka na sa ibang lugar. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
                CAST_VOTE_UnknownError: "Nagkaroon ng hindi kilalang error habang bumoboto. Pakisubukang muli mamaya o makipag-ugnayan sa suporta para sa tulong.",
                NO_BALLOT_SELECTION: "Walang estado ng pagpili para sa halalan na ito. Pakitiyak na tama ang iyong pagpili o makipag-ugnayan sa helpdesk.",
                NO_BALLOT_STYLE: "Walang estilo ng balota. Pakikontak ang helpdesk.",
                NO_AUDITABLE_BALLOT: "Walang balota na maaring suriin. Pakikontak ang helpdesk.",
                INCONSISTENT_HASH: "Nagkaroon ng error kaugnay sa proseso ng pag-hash ng balota. BallotId: {{ballotId}} ay hindi tugma sa sinusuring Hash ng Balota: {{auditableBallotHash}}. Pakireport itong isyu sa helpdesk.",
                ELECTION_EVENT_NOT_OPEN: "Ang kaganapan ng halalan ay sarado na. Pakikontak ang helpdesk.",
                PARSE_ERROR: "Nagkaroon ng error sa pag-parse ng balota. Pakisubukan ulit mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                DESERIALIZE_AUDITABLE_ERROR: "Nagkaroon ng error sa pag-deserialize ng sinusuring balota. Pakisubukan ulit mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                DESERIALIZE_HASHABLE_ERROR: "Nagkaroon ng error sa pag-deserialize ng hashable na balota. Pakisubukan ulit mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                CONVERT_ERROR: "Nagkaroon ng error sa pag-convert ng balota. Pakisubukan ulit mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                SERIALIZE_ERROR: "Nagkaroon ng error sa pag-serialize ng balota. Pakisubukan ulit mamaya o makipag-ugnayan sa helodesk para sa tulong.",
                UNKNOWN_ERROR: "Nagkaroon ng error. Pakisubukan ulit mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                REAUTH_FAILED: "Nabigo ang authentication. Pakisubukan muli o makipag-ugnayan sa helpdesk para sa tulong.",
                SESSION_EXPIRED: "Ang iyong session ay nag-expire na. Pakisubukan muli mula sa simula.",
                CAST_VOTE_BallotIdMismatch: "Hindi tumutugma ang ballot ID sa ibinotong boto.",
                SESSION_STORAGE_ERROR: "Hindi magamit ang session storage. Pakisubukang muli o makipag-ugnayan sa support.",
                PARSE_BALLOT_DATA_ERROR: "Nagkaroon ng error sa pag-parse ng data ng balota. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
                NOT_VALID_BALLOT_DATA_ERROR: "Ang data ng balota ay hindi wasto. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
                FETCH_DATA_TIMEOUT_ERROR: "May error sa timeout sa pagkuha ng data. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
                TO_HASHABLE_BALLOT_ERROR: "May error sa pag-convert sa hashable na balota. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
                INTERNAL_ERROR: "Nagkaroon ng internal error habang nagboboto. Pakisubukang muli mamaya o makipag-ugnayan sa support para sa tulong.",
            },
            declineToVote: "Tumangging bumoto",
            blankBallot: "Blangkong balota",
        },
        confirmationScreen: {
            acclamation: {
                title: "Napagpasyahan sa pamamagitan ng aklamasyon",
                description: "Lahat ng paligsahan sa halalang ito ay napagpasyahan sa pamamagitan ng aklamasyon, kaya walang balotang isinumite at walang ballot ID na masusubaybayan.",
                helpDialog: {
                    title: "Impormasyon: Aklamasyon",
                    content: "Lahat ng paligsahan sa halalang ito ay napagpasyahan sa pamamagitan ng aklamasyon: ang mga kandidato nito ay nahalal nang walang botohan. Dahil walang balotang isinumite, walang ballot ID, resibo, o QR code na maaaring i-verify.",
                    ok: "OK",
                },
            },
            title: "Ang iyong boto ay nai-submit na",
            description: "Ang code ng kumpirmasyon sa ibaba ay nagpapatunay na <b>ang iyong balota ay matagumpay na nai-submit</b>. Maaari mong gamitin ang code na ito upang tiyakin na ang iyong balota ay nabilang.",
            blankBallot: {
                description: "Ang iyong balota ay naisumite bilang blangko, na isang wasto at sinasadyang pagpili.",
            },
            ballotId: "ID ng Balota",
            printButton: "I-print",
            finishButton: "Tapos na",
            remainingElectionsError: "Hindi namin masuri kung mayroon ka pang ibang eleksiyong maaaring botohan. Pakisubukang muli.",
            retryButton: "Subukang muli",
            verifyCastTitle: "Tiyakin na ang iyong balota ay nai-submit",
            verifyCastDescription: "Maaari mong tiyakin na ang iyong balota ay nai-submit nang tama anumang oras gamit ang sumusunod na QR code:",
            confirmationHelpDialog: {
                title: "Tungkol sa screen ng kumpirmasyon",
                content: "Ipinapakita ng screen na ito na ang iyong boto ay matagumpay na nai-submit. Maaari mong tiyakin na ang balota ay nai-submit sa ballot box.",
                ok: "OK",
            },
            demoPrintDialog: {
                title: "Pagpi-print ng balota",
                content: "Ang pagpi-print ay hindi pinapayagan sa demo mode",
                ok: "OK",
            },
            demoBallotUrlDialog: {
                title: "ID ng Balota",
                content: "Hindi maaaring gamitin ang code, hindi pinapayagan sa demo mode.",
                ok: "OK",
            },
            ballotIdHelpDialog: {
                title: "Tungkol sa ID ng Balota",
                content: "Ang ID ng Balota ay isang code na maari mong gamitin upang hanapin ang iyong balota sa ballot box, ang ID na ito ay natatangi at hindi naglalaman ng impormasyon tungkol sa iyong mga napili.",
                ok: "OK",
            },
            ballotIdDemoHelpDialog: {
                title: "Tungkol sa Ballot ID",
                content: "Ang Ballot ID ay isang code na maari mong gamitin upang hanapin ang iyong balota sa ballot box, ang ID na ito ay natatangi at hindi naglalaman ng impormasyon tungkol sa iyong mga napili.",
                ok: "OK",
            },
            errorDialogPrintBallotReceipt: {
                title: "Error",
                content: "Nagkaroon ng error, pakisubukan muli",
                ok: "OK",
            },
            demoQRText: "Ang ballot tracker ay hindi gumagana sa demo mode",
        },
        auditScreen: {
            confirmingAudit: "Kinukumpirmang hindi na maaaring isumite ang balotang ito…",
            auditUnavailable: "Hindi nasuri ang balota. Hindi pa ipinapakita ang nilalaman nito. Pakisubukang muli.",
            printButton: "I-print",
            restartButton: "Simulan ang Pagboto",
            title: "Suriin ang Iyong Balota",
            description: "Upang suriin ang iyong balota, sundin ang mga hakbang sa ibaba:",
            step1Title: "1. I-download o kopyahin ang sumusunod na impormasyon",
            step1Description: "Ang iyong <b>Ballot ID</b> na makikita sa taas ng screen at ang iyong naka-encrypt na balota sa ibaba:",
            step1HelpDialog: {
                title: "Kopyahin ang Naka-encrypt na Balota",
                content: "Maaari mong i-download o kopyahin ang iyong naka-encrypt na balota upang suriin ang balota at tiyakin na ang naka-encrypt na nilalaman ay naglalaman ng iyong mga pinili.",
                ok: "OK",
            },
            downloadButton: "I-download",
            step2Title: "2. I-verify ang iyong balota",
            step2Description: "<VerifierLink>Access sa ballot verifier</VerifierLink>, isang bagong tab ang magbubukas sa iyong browser.",
            step2HelpDialog: {
                title: "Tutorial sa Pagsusuri ng Balota",
                content: "Upang suriin ang iyong balota, kailangan mong sundin ang mga hakbang na ipinapakita sa tutorial. Kasama rito ang pag-download ng isang desktop application na ginagamit upang i-verify ang naka-encrypt na balota nang hiwalay mula sa website.",
                ok: "OK",
            },
            bottomWarning: "Para sa mga dahilan ng seguridad, kapag sinusuri mo ang iyong balota, kailangan itong ipawalang-bisa. Upang magpatuloy sa proseso ng pagboto, kailangan mong i-click ang ‘<b>Simulan ang Pagboto</b>’ sa ibaba.",
        },
        electionSelectionScreen: {
            title: "Mga Balota",
            description: "Pumili ng Balota na nais mong botohan",
            chooserHelpDialog: {
                title: "Tungkol sa listahan ng balota",
                content: "Ipinapakita ng screen na ito ang listahan ng mga Balota na maaari mong botohan. Magkakaroon ka ng access kung nakabukas ang panahon ng pagboto.",
                ok: "OK",
            },
            noResults: "Walang mga balota sa ngayon.",
            resultsButton: "Tingnan ang mga resulta",
            demoDialog: {
                title: "Demo Voting Booth",
                content: "Ikaw ay nasa isang demo voting booth. <strong>Ang iyong boto ay hindi mai-susubmit.</strong> Para lamang sa layunin ng demonstrasyon.",
                ok: "Naiintindihan ko na ang aking boto ay hindi mai-susubmit",
            },
            errors: {
                noVotingArea: "Hindi ka nakalista bilang botante sa halalan na ito. Mangyaring makipag-ugnayan sa suporta.",
                networkError: "Nagkaroon ng problema sa network. Mangyaring subukan muli mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                unableToFetchData: "Nagkaroon ng problema sa pagkuha ng data. Mangyaring subukan muli mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                noElectionEvent: "Walang kaganapan ng halalan. Mangyaring subukan muli mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                ballotStylesEmlError: "Nagkaroon ng error sa pag-publish ng estilo ng balota. Mangyaring subukan muli mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                obtainingElectionFromID: "Nagkaroon ng error sa pagkuha ng mga halalan na nauugnay sa mga sumusunod na election IDs: {{electionIds}}. Mangyaring subukan muli mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
            },
            alerts: {
                noElections: "Walang mga halalan na maaari mong botohan. Ito ay maaring dahil walang naka-ugnay na paligsahan sa lugar. Mangyaring subukan muli mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
                electionEventNotPublished: "Ang kaganapan ng halalan ay hindi pa nailathala. Mangyaring subukan muli mamaya o makipag-ugnayan sa helpdesk para sa tulong.",
            },
            materialsGate: {
                instructions: "Kailangan mong basahin ang <MaterialsLink>{{materialsTitle}}</MaterialsLink> bago ka makaboto.",
            },
            votingClosedAt: "Nagsara ang botohan noong {{close}} ({{localClose}}).",
            votingClosedOn: "Nagsara ang botohan noong {{close}}.",
        },
        errors: {
            encoding: {
                notEnoughChoices: "Hindi sapat ang mga pagpili para ma-decode",
                writeInChoiceOutOfRange: "Ang write-in na pagpili ay wala sa saklaw: {{index}}",
                writeInNotEndInZero: "Ang write-in ay hindi nagtatapos sa 0",
                bytesToUtf8Conversion: "Error sa pag-convert ng write-in mula sa bytes patungong UTF-8 na string: {{errorMessage}}",
                ballotTooLarge: "Ang balota ay mas malaki kaysa sa inaasahan",
            },
            explicit: {
                notAllowed: "Ang balota ay tahasang minarkahang hindi wasto ngunit hindi ito pinapayagan ng paligsahan",
                alert: "Ang pagpiling ito ay biblangin bilang isang hindi wastong boto",
            },
            page: {
                oopsWithStatus: "Oops! {{status}}",
                oopsWithoutStatus: "Oops! Hindi inaasahang Error",
                somethingWrong: "May nangyaring hindi tama.",
                invalidLoginHintParametersTitle: "Hindi wastong link sa pagboto",
                invalidLoginHintParametersMessage: "Naglalaman ang link na ito ng hindi wastong impormasyon sa pag-login. Humiling ng bagong link at subukan muli.",
                certAuthFailedTitle: "Nabigo ang Pagpapatunay ng Sertipiko",
                certAuthFailedMessage: "Hindi ma-verify ang iyong sertipiko. Pakitiyak na gumagamit ka ng wastong sertipiko ng botante at subukang muli.",
            },
        },
        materials: {
            common: {
                label: "Mga Pangsuportang Materyales",
                back: "Bumalik sa listahan ng mga balota",
                close: "Isara",
                preview: "Silipin",
                download: "I-download",
            },
            mandatory: {
                checkboxLabel: "Nabasa ko na ang Mga Pangsuportang Materyales",
                continueButton: "Magpatuloy",
                error: "Nagkaroon ng problema sa pagre-record ng iyong kumpirmasyon. Pakisubukan muli.",
            },
        },
        slates: {
            title: "Mga slate",
            description: "Ang slate ay isang pangkat ng mga kandidatong magkakasamang tumatakbo. Ipinapakita ng bawat kandidato ang slate na kinabibilangan nila.",
            independent: "Independiyente",
            contestMembers: "Mga kandidato ng {{slate}} para sa {{contest}}",
            noCandidate: "Walang kandidato",
            coverage: {
                full: "Buong slate",
                singleContest: "{{contest}} lamang",
                partial: "Bahagyang slate",
                candidates_one: "{{count}} kandidato",
                candidates_other: "{{count}} kandidato",
                offices_one: "{{count}} posisyon",
                offices_other: "{{count}} posisyon",
            },
            candidateList: {
                show: "Ipakita ang mga kandidato",
                hide: "Itago ang mga kandidato",
            },
            tabs: {
                label: "Mga paraan ng pagsagot sa iyong balota",
                slates: "Pumili ng slate",
                candidates: "Mga indibidwal na kandidato",
            },
            review: {
                title: "Ang iyong mga pinili",
                total: "Mga kandidatong napili: {{selected}} sa {{seats}}",
                slate: "{{slate}}: {{status}}",
                independent: "Mga independiyenteng kandidatong napili: {{count}}",
                note: "Itinatala ang iyong boto para sa bawat napiling kandidato. Ang slate ay hindi hiwalay na boto.",
                contestCount: "{{selected}} sa {{max}} ang napili",
                edit: "Baguhin",
                editLabel: "Baguhin ang {{contest}}",
            },
            selection: {
                all: "Napili ang lahat ng {{total}}",
                mixed: "Halo · {{selected}} sa {{total}} ang napili",
                partly: "Bahagyang napili · {{selected}} sa {{total}}",
                selected: "Napili",
                edit: "Baguhin ang mga pinili",
            },
            apply: {
                button: "Piliin ang slate na ito",
                buttonLabel: "Piliin ang slate na {{slate}}",
                chosen: "Napili ang {{slate}}. Mga napiling kandidato: {{candidates}}. Mga paligsahan: {{contests}}.",
                overMaximum: "Hindi mapipili ang {{slate}}: mayroon itong {{candidates}} kandidato para sa {{contest}}, na {{max}} lamang ang pinapayagan. Maaari ka pa ring pumili ng mga kandidato nang isa-isa.",
                unavailable: "Hindi mapipili ang {{slate}} sa balotang ito. Maaari ka pa ring pumili ng mga kandidato nang isa-isa.",
                replaceDialog: {
                    title: "Palitan ang iyong kasalukuyang mga pinili?",
                    content: "Kapag pinili ang {{slate}}, mapapalitan ang iyong mga pinili sa mga paligsahan sa ibaba. Hindi magbabago ang iba mo pang pinili.",
                    removed: "Aalisin:",
                    added: "Pipiliin bilang kapalit:",
                    ok: "Palitan ang mga pinili",
                    cancel: "Panatilihin ang aking mga pinili",
                },
            },
        },
        ballotLocator: {
            title: "Hanapin ang Iyong Balota",
            titleResult: "Resulta ng Iyong Paghahanap ng Balota",
            description: "Patunayan na ang iyong balota ay tama na naipasa",
            locate: "Hanapin ang Iyong Balota",
            locateAgain: "Hanapin ang Isa Pang Balota",
            found: "Ang iyong ballot ID {{ballotId}} ay natagpuan",
            notFound: "Ang iyong ballot ID {{ballotId}} ay hindi natagpuan",
            ambiguous: "Higit sa isa sa iyong mga balota ang tumutugma sa {{ballotId}}. Gamitin ang buong Ballot ID.",
            contentDesc: "Ito ang nilalaman ng iyong balota: ",
            wrongFormatBallotId: "Mali ang format para sa Ballot ID",
            ballotIdNotFoundAtFilter: "Hindi natagpuan ang iyong ballot ID sa filter",
            filterByBallotId: "Tumutugma sa Ballot ID",
            totalBallots: "Kumulang mga balota: {{total}}",
            checksAvailableUntil: "Maaari mong suriin ang iyong balota hanggang {{date}}.",
            checksEnded: "Natapos ang mga pagsusuri noong {{date}}.",
            castAt: "Naihulog noong {{date}}",
            steps: {
                lookup: "Hanapin ang Iyong Balota",
                result: "Resulta",
            },
            titleHelpDialog: {
                title: "Tungkol sa Tagahanap ng Balota",
                content: "Ang Tagahanap ng Balota ay nagbibigay-daan sa iyo na ilagay ang Ballot ID upang hanapin ang iyong boto at tiyakin na ito ay tamang nairehistro.",
                ok: "OK",
            },
            tabs: {
                logs: "Logs",
                ballotLocator: "Tagahanap ng Balota",
            },
            column: {
                statement_kind: "Uri",
                statement_timestamp: "Timestamp",
                ballot_id: "Ballot ID",
            },
        },
    },
};
export default tagalogTranslation;
